import React from 'react';
import { motion } from 'framer-motion';

function ColorSlider({ label, value, onChange, color }) {
  const getSliderGradient = () => {
    switch (color) {
      case 'red':
        return 'from-black via-red-500 to-red-300';
      case 'green':
        return 'from-black via-green-500 to-green-300';
      case 'blue':
        return 'from-black via-blue-500 to-blue-300';
      default:
        return 'from-gray-600 to-gray-300';
    }
  };

  const getThumbColor = () => {
    switch (color) {
      case 'red':
        return 'bg-red-500';
      case 'green':
        return 'bg-green-500';
      case 'blue':
        return 'bg-blue-500';
      default:
        return 'bg-gray-500';
    }
  };

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <span className="text-white font-medium">{label}</span>
        <div className="bg-white/20 rounded-lg px-3 py-1">
          <span className="text-white font-mono text-sm">{value}</span>
        </div>
      </div>
      
      <div className="relative">
        <div className={`h-3 rounded-full bg-gradient-to-r ${getSliderGradient()}`} />
        <motion.div
          className={`absolute top-1/2 w-6 h-6 ${getThumbColor()} rounded-full border-2 border-white shadow-lg cursor-pointer transform -translate-y-1/2`}
          style={{ left: `${(value / 255) * 100}%`, marginLeft: '-12px' }}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
        />
        <input
          type="range"
          min="0"
          max="255"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />
      </div>
    </div>
  );
}

export default ColorSlider;